import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "social-media-posts"
}
const _hoisted_2 = {
  key: 0,
  id: "social-media",
  class: "card py-2 px-2"
}
const _hoisted_3 = { class: "py-1 px-2" }
const _hoisted_4 = { class: "py-1" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  id: "social-media",
  class: "card py-2 px-2"
}
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_edit_social_post = _resolveComponent("edit-social-post")!
  const _component_delete_social_post = _resolveComponent("delete-social-post")!
  const _component_create_social_post = _resolveComponent("create-social-post")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[3] || (_cache[3] = _createElementVNode("div", null, [
      _createElementVNode("h1", null, "Social Media Posts")
    ], -1)),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.posts.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("table", null, [
                  _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { class: "header-row py-2 px-2" }, "Title"),
                      _createElementVNode("th", { class: "header-row py-2" }, "Date"),
                      _createElementVNode("th", { class: "header-row py-2" })
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posts, (post, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_3, _toDisplayString(post.title), 1),
                        _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.moment(post.published_on).format('YYYY-MM-DD')), 1),
                        _createElementVNode("td", null, [
                          (_openBlock(), _createBlock(_component_edit_social_post, {
                            "post-obj": post,
                            onUpdatePostData: _ctx.updateSocialPost,
                            key: post.id
                          }, {
                            trigger: _withCtx((triggerProps) => [
                              _createElementVNode("button", {
                                onClick: triggerProps.click,
                                class: "ms-4 btn btn-primary btn-sm"
                              }, "Edit Post", 8, _hoisted_5)
                            ]),
                            _: 2
                          }, 1032, ["post-obj", "onUpdatePostData"])),
                          _cache[0] || (_cache[0] = _createTextVNode("   ")),
                          (_openBlock(), _createBlock(_component_delete_social_post, {
                            "post-obj": post,
                            onDeletePostData: ($event: any) => (_ctx.deleteSocialPost(index)),
                            key: post.id
                          }, {
                            trigger: _withCtx((triggerProps) => [
                              _createElementVNode("button", {
                                onClick: triggerProps.click,
                                class: "ms-4 btn btn-primary btn-sm"
                              }, "Delete", 8, _hoisted_6)
                            ]),
                            _: 2
                          }, 1032, ["post-obj", "onDeletePostData"]))
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[2] || (_cache[2] = [
                _createElementVNode("table", null, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { class: "header-row py-2 px-2" }, "Title"),
                      _createElementVNode("th", { class: "header-row py-2" }, "Date"),
                      _createElementVNode("th", { class: "header-row py-2" })
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        class: "text-center",
                        colspan: "3"
                      }, "There are no social media posts at this time.")
                    ])
                  ])
                ], -1)
              ]))),
          _createVNode(_component_create_social_post, { onUpdate: _ctx.newSocialPost }, {
            trigger: _withCtx((triggerProps) => [
              _createElementVNode("button", {
                onClick: triggerProps.click,
                class: "ms-2 my-4 btn btn-primary"
              }, "Create New Social Media Post", 8, _hoisted_8)
            ]),
            _: 1
          }, 8, ["onUpdate"])
        ]))
      : _createCommentVNode("", true),
    _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}